import { api } from "@/api"
import { ROUTES } from "@/constants/routes"

const NETWORK_CHECK_ERROR_MESSAGE =
  "접속 위치를 확인하지 못했습니다. 잠시 후 다시 시도해주세요."

export async function interviewEntryMiddleware (to, from, next) {
  try {
    const response = await api.auth.checkIpCidr({}, { monitorTargetPath: to.path })
    next({
      name:
        response.data === true
          ? ROUTES.INTERVIEW.DOCUMENT_ROOT
          : ROUTES.INTERVIEW.GENERAL_ROOT,
    })
  } catch (error) {
    alert(NETWORK_CHECK_ERROR_MESSAGE)
    next(false)
  }
}

export async function documentInterviewMiddleware (to, from, next) {
  try {
    const response = await api.auth.checkIpCidr({}, { monitorTargetPath: to.path })
    if (response.data === true) {
      next()
      return
    }

    alert(
      "서류면접은 학교망에서만 이용할 수 있습니다. 일반면접으로 이동합니다.",
    )
    next({ name: ROUTES.INTERVIEW.GENERAL_ROOT })
  } catch (error) {
    alert(NETWORK_CHECK_ERROR_MESSAGE)
    next(false)
  }
}
